// src/components/SaleBanner.js
import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { apiRequest } from "../services/api";

function SaleBanner() {
  const navigate = useNavigate();
  const { lang } = useContext(LanguageContext);
  const [banner, setBanner] = useState(null);
  const [animate, setAnimate] = useState(true);

  useEffect(() => {
    apiRequest("/sale-banner")
      .then(setBanner)
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!banner) return;
    const interval = setInterval(() => {
      setAnimate(false);
      setTimeout(() => setAnimate(true), 150);
    }, 2000);
    return () => clearInterval(interval);
  }, [banner]);

  if (!banner) return null;

  return (
    <button
      onClick={() => 
 navigate("/products?category=sale", {
      state: { from: "home" },
    })
  }
      className="w-full relative text-center py-2.5 px-4 mt-2 overflow-hidden"
      style={{
        background: "linear-gradient(135deg, #1A1A1A, #2A2A2A, #1A1A1A)",
        backgroundSize: "200% 200%",
        animation: "gradientShift 10s ease-in-out infinite",
      }}
    >
      <div className="absolute inset-0 bg-white/5 pointer-events-none"></div>

      <p className="text-[17px] font-extrabold text-white">
        {lang === "EN" ? banner.title_en : banner.title_ar}
      </p>

      <p
        className={`text-4xl font-extrabold mt-[2px] text-white transition-all ${
          animate ? "scale-110" : "scale-95"
        }`}
      >
        {banner.discount}% {lang === "EN" ? "OFF" : "خصم"}
      </p>

      <p className="text-[11px] mt-1 text-white/90">
        {lang === "EN"
          ? banner.description_en
          : banner.description_ar}
      </p>
    </button>
  );
}

export default SaleBanner;

